import React from "react";
import { useParams } from "react-router-dom";
import { Outlet } from "react-router";
import CommonHero from "../layout/common/commonHero";
import Navbar from "../layout/homePage/navbar/navbar";
import HomePageFooter from "../layout/homePage/footer/HomePageFooter";
import BlogDetail from "../layout/blogs/detail/BlogDetail";
import BlogHero from "../layout/blogs/hero/BlogHero";
export default function BlogDetails() {
  const { id } = useParams(); // if you want to fetch dynamic blog by id later

  // Dummy blog data for now
  const blog = {
    title: "Yamaha R15 V4 — The Ultimate Urban Sports Bike",
    category: "Bikes",
    date: "October 15, 2025",
    tags: ["Performance", "Racing", "Yamaha", "Sport"],
    coverImage:
      "https://images.unsplash.com/photo-1592194996308-7b43878e84a6?auto=format&fit=crop&w=1200&q=80",
    content: `
      The Yamaha R15 V4 brings an upgraded aerodynamic design, improved riding ergonomics,
      and superior engine performance. This model stands out with its quick-shifter, dual-channel ABS,
      and aggressive LED headlamps for a thrilling road experience.
    `,
    images: [
      "https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1525609004556-c46c7d6cf023?auto=format&fit=crop&w=800&q=80",
    ],
    technicalSpecs: {
      length: "1990 mm",
      width: "725 mm",
      height: "1135 mm",
      weight: "142 kg",
      fuelCapacity: "11 liters",
    },
    engineSpecs: {
      type: "155cc, Liquid-cooled, 4-stroke, SOHC",
      power: "18.4 PS @ 10000 rpm",
      torque: "14.2 Nm @ 7500 rpm",
      gearbox: "6-speed",
    },
    service: {
      warranty: "2 years or 30,000 km (whichever earlier)",
      serviceInterval: "Every 3000 km or 3 months",
    },
  };

  return (
     <>
    <Navbar />
    <BlogDetail />
    <Outlet />
    <HomePageFooter />
  </>
  );
}
